import { IonButton, IonIcon } from '@ionic/react';
import { umbrella } from 'ionicons/icons';
import { createUseStyles } from 'react-jss';
import { ForwardIcon } from '../components/icons/Icons.tsx';
import { SkywatchService } from './SkywatchService.ts';
import { useInstance } from '@meraki-internal/react-dependency-injection';

const useStyles = createUseStyles(() => ({
    quoteButton: {
        height: 100,
        '--padding-start': '0px',
        '--padding-end': '0px'
    }
}));

const StartArrow: React.FC<{label?: string}> = ({ label = '' }) => (
    <div style={{
        minWidth: label ? 80 : 55,
        height: 40,
        paddingLeft: label ? 40 : 15,
        paddingRight: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: 10,
        backgroundColor: 'var(--ion-color-insurance)',
        color: 'white',
        borderTopLeftRadius: 20,
        borderBottomLeftRadius: 20
    }}>
        <b>{label}</b>
        <ForwardIcon size="medium" />
    </div>
);

export const NewPolicyButton: React.FC = () => {
    const classes = useStyles();
    const skywatch = useInstance(SkywatchService);

    return (
        <div style={{margin: '20px 15px'}}>

            <IonButton data-id="new-policy-button" size="large" color="secondary" className={classes.quoteButton} expand="block" onClick={() => skywatch.getQuote({ trackingFrom: 'marketing' })}>

                <div style={{display: 'flex', alignItems: 'center', gap: 10, width: '100%'}}>

                    <div style={{width: 50, marginLeft: 10, flexShrink: 0, flexGrow: 0}}>
                        <IonIcon icon={umbrella} color="light" style={{fontSize: 35}} />
                    </div>

                    <div style={{display: 'flex', flexDirection: 'column', flexShrink: 1, flexGrow: 1, alignItems: 'start', whiteSpace: 'pre-wrap', textAlign: 'left'}}>
                        <h3 style={{marginTop: 0, marginBottom: 5}}><b>Get a Free Quote</b></h3>
                        <small style={{lineHeight: 1, color: 'var(--ion-color-step-300)'}}>No credit card needed!</small>
                    </div>

                    <StartArrow />

                </div>

            </IonButton>
        </div>
    );
};
